import React from 'react';

import SendMessageModal from './SendMessageModal';
import IssueReceipt from './IssueReceiptModal';
import ConfirmOrderDuplicate from './ConfirmOrderDuplicate';
import ConfirmDeleteModal from './ConfirmDeleteModal';
import ChangeStateModal from './ChangeStateModal';

const ContextMenuModal = ({ type, order, open, handleClose, removeOrderFromOrders, addOrder }) => {

  if (type === 'sendMessage') {
    return <SendMessageModal order={order} open={open} handleClose={handleClose} />;
  } else if (type === 'issueReceipt') {
    return <IssueReceipt order={order} open={open} handleClose={handleClose} />;
  } else if (type === 'deleteOrder') {
    return <ConfirmDeleteModal order={order} open={open} handleClose={handleClose} removeOrderFromOrders={removeOrderFromOrders} />;
  } else if (type === 'duplicateOrder') {
    return <ConfirmOrderDuplicate order={order} open={open} handleClose={handleClose} addOrder={addOrder} />;
  } else if (type === 'changeState') {
    return <ChangeStateModal order={order} open={open} handleClose={handleClose} />;
  }

  return null;

};

export default ContextMenuModal;
